// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__daaak","tooltipText":"styles_tooltipText__YNxg4"};